var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bd desc-box",attrs:{"id":"contest-bd"}},[_c('div',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.detail.notice_web)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }